import { jsxs as d, jsx as C } from "react/jsx-runtime";
import { getMainIconProps as n } from "./index.es2444.js";
const t = (o) => {
  const { outline: l, fill: i, size: e } = n(o);
  return /* @__PURE__ */ d(
    "svg",
    {
      width: e,
      height: e,
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.6577 18H4.65771V17.25H12.6577V18Z",
            fill: i
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M8.41011 15.5319C8.41014 15.5319 8.41017 15.5319 8.65743 15.25C8.90469 15.5319 8.90536 15.5313 8.9054 15.5313L8.65743 15.7488L8.41011 15.5319Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.6573 3.79346C7.12999 3.79346 5.8913 5.03355 5.8913 6.56046C5.8913 8.08846 7.13009 9.32746 8.6573 9.32746C10.1854 9.32746 11.4243 8.08856 11.4243 6.56046C11.4243 5.03345 10.1855 3.79346 8.6573 3.79346ZM6.6413 6.56046C6.6413 5.44736 7.54461 4.54346 8.6573 4.54346C9.77109 4.54346 10.6743 5.44746 10.6743 6.56046C10.6743 7.67435 9.77119 8.57746 8.6573 8.57746C7.54451 8.57746 6.6413 7.67445 6.6413 6.56046Z",
            fill: l
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.41011 15.5319L8.65743 15.25L8.9054 15.5313L8.94569 15.4959L9.06186 15.3935C9.16238 15.3047 9.30707 15.1765 9.48402 15.0188C9.83784 14.7035 10.321 14.2698 10.8379 13.7963C11.8642 12.8564 13.0478 11.7384 13.6029 11.0862C14.7289 9.76453 15.3154 8.3625 15.3154 6.645C15.3154 2.97593 12.3406 0 8.67043 0H8.64543C4.97528 0 2.00043 2.97593 2.00043 6.645C2.00043 8.36246 2.58697 9.76444 3.71185 11.086C4.26689 11.7382 5.45054 12.8563 6.4769 13.7963C6.99388 14.2698 7.47701 14.7035 7.83084 15.0188C8.00778 15.1765 8.15248 15.3047 8.25299 15.3935L8.36916 15.4959L8.41011 15.5319ZM2.75043 6.645C2.75043 3.39007 5.38957 0.75 8.64543 0.75H8.67043C11.9263 0.75 14.5654 3.39007 14.5654 6.645C14.5654 8.1615 14.0579 9.39562 13.0318 10.6C12.5129 11.2098 11.3665 12.2952 10.3314 13.2432C9.81763 13.7137 9.33714 14.1451 8.98502 14.4589C8.85741 14.5726 8.74669 14.6709 8.65743 14.7499C8.56816 14.6709 8.45745 14.5726 8.32983 14.4589C7.97772 14.1451 7.49723 13.7137 6.98345 13.2432C5.94831 12.2952 4.80195 11.2097 4.28299 10.5999C3.25788 9.39555 2.75043 8.16153 2.75043 6.645Z",
            fill: l
          }
        )
      ]
    }
  );
};
t.__tags = [];
export {
  t as LocationMarkIcon
};
//# sourceMappingURL=index.es311.js.map
